import request from "../request";

/**
 * 创建模板
 */
export function createdPerformanceTemplate(item) {
    return request({
        url: 'sys/Performance/AddPerformance',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: item
    })
}
/**
 * 导入模板
 */
export function importPerformanceTemplate(item) {
    return request({
        url: '/sys/Performance/importPerformance',
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        method: 'POST',
        data: item,
    })
}


/**
 * 更新模板
 */
export function updatePerformanceTemplate(item) {
    return request({
        url: 'sys/Performance/updatePerformance',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: item
    })
}

/**
 * 绩效模板分页
 */
export function selectPerformanceTemplate(query) {
    return request({
        url: '/sys/Performance/getPerformancePage',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: query
    })
}

/**
 * 根据模板id 查询模板详细信息然后进行修改模板
 */
export function selectPerformanceTemplateDetailsById(item) {
    return request({
        url: 'sys/Performance/GetPerformanceDetails',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: item
    })
}

export function deletePerformanceTemplateById(item) {
    return request({
        url: 'sys/Performance/deletePerformance',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: item
    })
}

/**
 * 查询我的绩效表
 */
export function myPerformance(item) {
    return request({
        url: 'sys/Performance/MyPerformance',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: item
    })
}
/**
 * 更新我的绩效表
 */
export function updateMyPerformance(item) {
    return request({
        url: 'sys/Performance/updateMyPerformance',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: item
    })
}


/**
 * 查询全部人员的绩效分页
 */
export function selectPerformancePage(query) {
    return request({
        url: 'sys/Performance/GetPerformancePage',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: query
    })
}
/**
 * 查询全部人员的绩效统计
 */
export function selectStatisticsPerformance(query) {
    return request({
        url: 'sys/Performance/StatisticsPerformance',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: query
    })
}

/**
 * 查询全部绩效列表 ---> 查询列表中的某个人的绩效
 */
export function selectPerformance(query) {
    return request({
        url: 'sys/Performance/VisualPerformance',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: query
    })
}

/**
 * 导出个人的计划表、绩效表 Excel表
 */
export function exportExcel(query) {
    return request({
        url: 'sys/Performance/getPerformanceModelExcel',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: query
    })
}

/**
 * 批量导出没个人的计划表、绩效表
 */
export function batchExportExcel(query) {
    return request({
        url: 'sys/Performance/getMorePerformanceModelExcel',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: query
    })
}

/**
 * 绩效表--消息提醒
 */
export function performanceRemind() {
    return request({
        url: 'sys/Performance/PopUpAPrompt',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
    })
}
/**
 * 绩效表--消息提醒-通知没有提交的老师：提交绩效
 */
export function sendPerformanceRemind(type) {
    return request({
        url: 'sys/Performance/SendPerformanceRemind',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: type,
    })
}

/**
 * 绩效表--人事消息提醒-查询没有提交绩效的老师列表
 */
export function personnelLookPerformance() {
    return request({
        url: 'sys/Performance/PersonnelLookPerformance',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
    })
}


/**
 * 驳回计划、绩效表
 */
export function sendPerformanceRejectRemind(item) {
    return request({
        url: 'sys/Performance/SendPerformanceRejectRemind',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: item
    })
}


/**
 * 导出总得分
 */
export function getPerformanceScoreExcel(item) {
    return request({
        url: 'sys/Performance/getPerformanceScoreExcel',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: item
    })
}
